import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { parse } from 'query-string';

import { CustomTableHeadersProps } from '@dev/ee-components';
import { DeliveryLogType, StatusMessageCategory } from '@dev/ee-api/ee-api-models';

import useMobile from '@/services/hooks/useMobile';
import { EventFilter } from '../../../assets/EventFilter';
import { useEventsFilterOptions } from '../../../assets/EventFilter/useEventsFilterOptions';

export const useTableHeaders = (
    onClickEventsFilter: (selected: (DeliveryLogType | StatusMessageCategory)[]) => void
): (CustomTableHeadersProps | string)[] => {
    const eventsOptions = useEventsFilterOptions();
    const { t } = useTranslation();
    const location = useLocation();
    const isMobile = useMobile();
    const query = parse(location.search, { parseBooleans: true });
    const isLastEvent = (query?.lastEvent as boolean) ?? true;

    if (isMobile) {
        return [t('to'), t('event'), t('date'), t('bouncetype')];
    }

    return [
        { id: 'to', headerAlign: 'left', label: t('recipient') },
        {
            id: 'logsDate',
            headerAlign: 'right',
            label: t('date'),
            columnAlign: 'right',
        },
        { id: 'emptyColumn', label: '' },
        {
            id: 'event',
            headerAlign: 'left',
            label: t('event'),
            filterIcon: !isLastEvent && (
                <EventFilter onHeadersEventFilterClick={onClickEventsFilter} options={eventsOptions} />
            ),
        },
        {
            id: 'bounce',
            headerAlign: 'left',
            label: t('bouncetype'),
        },
        { id: 'icon', headerAlign: 'right', label: '', columnAlign: 'right' },
    ];
};
